<script setup lang="ts">
import { inject } from 'vue'

import useBrandImageResolver from '@/components/useBrandImageResolver'

const props = defineProps<{
  src: string
  class?: string | { [index: string]: boolean } | undefined
}>()

const BRAND = inject('BRAND')
const brandImage = useBrandImageResolver(BRAND, props.src)
</script>

<template>
  <img
    :src="brandImage"
    :class="props.class"
  />
</template>
